import type { VoidFunctionComponent } from 'react';

import { SBOM_PORTAL_PRIVATE } from '../../../../../../shared/featureFlags/flagNames';
import Flex from '../../../../generic/Flex';
import FeatureFlagRequired from '../../../../generic/Gates/FeatureFlagRequired';
import { icons } from '../../../../generic/Icon/icons';
import { Icon } from '../../../../generic/Icon/index';
import { RouterLink } from '../../../../generic/Link/index';
import Tooltip from '../../../../generic/Tooltip';
import type { ReleaseGroup } from '../../../../../../shared/projectsV2';

type Props = {
  releaseGroup: ReleaseGroup;
};

const ReleaseGroupTitle: VoidFunctionComponent<Props> = ({ releaseGroup }: Props) => {
  const label = releaseGroup.projects === 1 ? 'project' : 'projects';

  return (
    <div className="release-group-item__overview">
      <div className="release-group-item__title">
        <Flex align="center" justify="left" wrap="nowrap" gap="5px">
          <RouterLink
            to={`/projects/group/${releaseGroup.id}`}
            className="projects-table__row__link"
          >
            <Tooltip showTooltip tooltip={releaseGroup.title}>
              <div className="release-group-item__title__link">{releaseGroup.title}</div>
            </Tooltip>
          </RouterLink>
          {
            !releaseGroup.publicOnPortal &&
            <FeatureFlagRequired flagName={SBOM_PORTAL_PRIVATE}>
              <Tooltip tooltip="Private">
                <span className="release-group-item__title_private-icon">
                  <Icon icon={icons.lock} />
                </span>
              </Tooltip>
            </FeatureFlagRequired>
          }
          <Tooltip tooltip={`${releaseGroup.projects} ${label}`}>
            <span className="release-group-item__title_icon">
              <Icon icon={icons.folder} />
              <span>{releaseGroup.projects}</span>
            </span>
          </Tooltip>
        </Flex>
      </div>
    </div>
  );
};

export default ReleaseGroupTitle;
